import React from 'react';

const QuestionsProgressBar = ({total, current, showCount = true}) => {
    return (
        <div className='questions-progress-bar flex flex-align-center mb-20'>
            <div className='progress-bar'>
                <div className='progress-filled' style={{ width: `${current*100/total}%` }} />
            </div>
            {showCount && <span className='count'>{current}</span>}
        </div>
    );
}

export default QuestionsProgressBar;